import axios from 'axios';
import config from 'config';
import getSetCookie from '../cookie';
// List of allowed lang for locale config
import { langCodeAllowed } from '../locales';
const __IS_LOCAL__ = process.env.IS_LOCAL_DEV;
let xApiClient = 'desktop';
let appXApiClients = [];
let userAgent = 'axios/0.18.1-desktop';
// conditional imports on compilation
('#if CLIENT_TYPE === "mobile"'); // eslint-disable-line
xApiClient = 'mobilesite';
appXApiClients = config.msiteGlobals.appXApiClients;
userAgent = 'axios/0.18.1-mobilesite';
('#endif'); // eslint-disable-line

// set user lang for locale specific data
const setUserLang = (_request, _response) => {
  let locale = 'en_IN';
  const countryCode = __SERVER__
    ? _request.cookies.countryCode
    : getSetCookie.getCookie('countryCode');
  if (countryCode) {
    const getLangObj = langCodeAllowed[countryCode]
      ? langCodeAllowed[countryCode]
      : langCodeAllowed.IN;
    const currentLocale = getLangObj ? getLangObj.defaultLocale : 'en_IN';
    // user selected locale
    locale = __SERVER__ ? _request.cookies.locale : getSetCookie.getCookie('locale');
    let isValidLocale = [];
    if (getLangObj) {
      isValidLocale = getLangObj.localeList.filter(x => x.code === locale);
    }
    if (isValidLocale.length === 0 || locale.indexOf(countryCode) === -1) {
      locale = currentLocale;
    }
  }
  if (__SERVER__) {
    _response.cookie('locale', locale, {
      domain: '.lenskart.com',
      path: '/',
      maxAge: 2592000000,
    });
  }
  /** SET LOCALE AS GLOBAL VARIABLE */
  global.__LOCALE__ = locale;
};

const getCommonHeader = ({ customHeader, req }) => {
  const headers = {
    'X-Api-Client': xApiClient,
    'Cache-Control': 'no-cache, no-store',
    'X-B3-TraceId': `99${Date.now()}`,
  };
  if ((__SERVER__ && req.cookies.frontend) || (__CLIENT__ && getSetCookie.getCookie('frontend'))) {
    headers['X-Session-Token'] = __SERVER__
      ? req.cookies.frontend
      : getSetCookie.getCookie('frontend');
  }
  ('#if CLIENT_TYPE === "mobile"'); // eslint-disable-line
  if (req && req.header('x-api-client') && appXApiClients.includes(req.header('x-api-client'))) {
    // did not use loop as iterators/generators require regenerator-runtime
    if (req.header('x-app-version')) {
      headers['x-app-version'] = req.header('x-app-version');
    }
    if (req.header('x-session-token')) {
      headers['X-Session-Token'] = req.header('x-session-token');
    }
    if (req.header('udid')) {
      headers.udid = req.header('udid');
    }
    if (req.header('device-id')) {
      headers['device-id'] = req.header('device-id');
    }
  }
  ('#endif'); // eslint-disable-line
  if (
    __CLIENT__ &&
    typeof window !== 'undefined' &&
    (window.location.href.indexOf('/v2/carts') !== -1 ||
      window.location.href.indexOf('campaign') !== -1) &&
    window.sessionStorage.getItem('userEmail') &&
    window.sessionStorage.getItem('userPh')
  ) {
    headers.email = window.sessionStorage.getItem('userEmail');
    headers.phone = window.sessionStorage.getItem('userPh');
  }
  return customHeader ? Object.assign({}, headers, customHeader) : headers;
};

export default function apiClient(apiObject) {
  const instance = axios.create();
  const _response = apiObject ? apiObject.res : null;
  const _request = apiObject ? apiObject.req : null;

  instance.interceptors.request.use(
    async request => {
      // Should only be enabled for dev environments
      // const reqObj = { Url: request.url, Method: request.method, Data: request.data || '' };
      // if (__SERVER__) {
      //   console.log(reqObj);
      // }
      // set user lang for locale specific data
      setUserLang(_request, _response);
      if (__CLIENT__) {
        if (request.url.indexOf('v2/sessions') > -1 && request.method === 'post') {
          return request;
        }
        if (!getSetCookie.getCookie('frontend')) {
          const response = await axios.post(config.apiPath.userSession, null, {
            headers: { 'X-Api-Client': xApiClient },
          });
          getSetCookie.setCookie('frontend', response.data.result.id, 30);
          request.headers['X-Session-Token'] = response.data.result.id;
        }
      }
      if (request.url.indexOf(':locale') !== -1) {
        if (__SERVER__ && __IS_LOCAL__ === 'ON') {
          request.url = 'http://localhost:8081' + request.url;
        }
        request.url = request.url.replace(':locale', global.__LOCALE__);
      }
      return request;
    },
    error => Promise.reject(error)
  );
  /** ENDS HERE */

  instance.interceptors.request.use(
    conf => {
      // Hack for PI-7430
      if (conf.url.indexOf('filters') > -1 && conf.headers['X-Api-Client']) {
        delete conf.headers['X-Api-Client'];
      }
      if (__SERVER__) {
        conf.headers['User-Agent'] = `${userAgent}${conf.headers.isBot ? '-seoBot' : ''}`;
      }
      delete conf.headers.isBot;
      return conf;
    },
    error => Promise.reject(error)
  );

  instance.interceptors.response.use(
    response => response.data,
    error => Promise.reject(error.response ? error.response.data : error)
  );
  instance.setHeader = function (customHeader) {
    this.defaults.headers = getCommonHeader({ req: _request, customHeader });
  };
  instance.withCredentials = function () {
    this.defaults.withCredentials = true;
  };
  instance.getServerRequestHeader = function () {
    return _request;
  };
  instance.getServerResponse = function () {
    return _response;
  };

  instance.validateSession = async function () {
    const requestUrl = __SERVER__
      ? config.apiPath.albValidateSession
      : config.apiPath.validateSession;

    const options = {
      headers: getCommonHeader({ req: _request }),
    };

    try {
      const response = await this.get(requestUrl, options);
      if (__SERVER__) {
        _response.cookie('isLogined', '0', {
          domain: '.lenskart.com',
          path: '/',
          maxAge: 2592000000,
        });
        _response.cookie('log_in_status', 'loggedout', {
          domain: '.lenskart.com',
          path: '/',
          maxAge: 2592000000,
        });
      } else if (__CLIENT__) {
        getSetCookie.setCookie('isLogined', '0', 30);
        getSetCookie.setCookie('log_in_status', 'loggedout', 30);
      }

      let isCartCount = 0;
      let isWishlistCount = 0;
      if (response.result.attrs.hasOwnProperty('cartIds') && response.result.attrs.itemsCount > 0) {
        isCartCount = response.result.attrs.itemsCount;
      }
      if (
        response.result.attrs.hasOwnProperty('wishlist') &&
        response.result.attrs.wishlist.length > 0
      ) {
        isWishlistCount = response.result.attrs.wishlist.length;
      }
      if (
        typeof response.result.attrs.isLoggedIn !== 'undefined' &&
        response.result.attrs.isLoggedIn
      ) {
        const res = await this.customerMe();
        if (__SERVER__) {
          _response.cookie('isLogined', '1', {
            domain: '.lenskart.com',
            path: '/',
          });
          _response.cookie('log_in_status', 'loggedin', {
            domain: '.lenskart.com',
            path: '/',
          });
        } else if (__CLIENT__) {
          getSetCookie.setCookie('isLogined', '1', 30);
          getSetCookie.setCookie('log_in_status', 'loggedin', 30);
        }
        res.result.isCartCount = isCartCount;
        res.result.isWishlistCount = isWishlistCount;
        res.result.login = true;
        return res;
      }
      response.result.isCartCount = isCartCount;
      response.result.isWishlistCount = isWishlistCount;
      response.result.login = false;
      return response;
    } catch (er) {
      throw er;
    }
  };

  // get category data
  /* eslint comma-spacing: 0 */
  instance.getCategoryData = async function (catID, params, pageSize, pageCounter, isExchange) {
    const requestUrl = __SERVER__ ? config.apiPath.albDataCategory : config.apiPath.dataCategory;
    const options = {
      headers: {
        'X-Api-Client': xApiClient,
        email: __CLIENT__ ? window.sessionStorage.getItem('userEmail') : '',
        phone: __CLIENT__ ? window.sessionStorage.getItem('userPh') : '',
      },
    };
    if (isExchange) {
      options.headers['X-Service-Type'] = 'exchange';
    }
    const getParams = params ? `&${params.replace('#', '')}` : '';
    const urlOption = `${catID}?page-size=${pageSize}&page=${pageCounter}${getParams}`;
    try {
      const response = await this.get(requestUrl + urlOption, options);
      return response;
    } catch (er) {
      throw er;
    }
  };
  // get product data
  instance.getProductData = async function (pID, params, isExchange) {
    const requestUrl = __SERVER__ ? config.apiPath.albDataProduct : config.apiPath.dataProduct;
    const options = {
      headers: {
        'X-Api-Client': xApiClient,
        email: __CLIENT__ ? window.sessionStorage.getItem('userEmail') : '',
        phone: __CLIENT__ ? window.sessionStorage.getItem('userPh') : '',
      },
    };
    if (isExchange) {
      options.headers['X-Service-Type'] = 'exchange';
    }
    const getParams = pID + (params ? `?${params}` : '');
    try {
      const response = await this.get(requestUrl + getParams, options);
      return response;
    } catch (er) {
      throw er;
    }
  };

  instance.customerMe = async function () {
    const requestUrl = __SERVER__ ? config.apiPath.albGetUserInfo : config.apiPath.getUserInfo;
    const options = {
      headers: getCommonHeader({ req: _request }),
    };
    try {
      return await this.get(requestUrl, options);
    } catch (er) {
      throw er;
    }
  };

  instance.customPost = async function (url, data, sessionKey, apiClient, cache, isExchange) {
    try {
      const header = {};
      if (apiClient !== null) header['X-Api-Client'] = apiClient;
      if (sessionKey !== null) {
        header[sessionKey] = getSetCookie.getCookie('frontend');
      }
      if (isExchange) {
        header['X-Service-Type'] = 'exchange';
      }
      if (cache !== null) header['Cache-Control'] = 'no-cache, no-store';
      if (url.indexOf('/v2/') !== -1) {
        header['X-B3-TraceId'] = `99${Date.now()}`;
      }
      if (
        __CLIENT__ &&
        (url.indexOf('/v2/carts') !== -1 || url.indexOf('campaign') !== -1) &&
        typeof window !== 'undefined'
      ) {
        header.email = __CLIENT__ ? window.sessionStorage.getItem('userEmail') : '';
        header.phone = __CLIENT__ ? window.sessionStorage.getItem('userPh') : '';
      }
      const extras = { headers: header };
      if (url.indexOf('/v2/orderpayment') !== -1) {
        extras.withCredentials = true;
      }
      const response = await this.post(url, data, extras);
      return response;
    } catch (er) {
      throw er;
    }
  };
  instance.getCmsData = async function (cmdId) {
    const requestUrl = config.apiPath.cmsPages;
    const options = {
      headers: {
        'X-Api-Client': xApiClient,
        email: __CLIENT__ ? window.sessionStorage.getItem('userEmail') : '',
        phone: __CLIENT__ ? window.sessionStorage.getItem('userPh') : '',
      },
    };
    const urlOption = `${cmdId}`;
    try {
      const response = await this.get(requestUrl + urlOption, options);
      return response;
    } catch (er) {
      console.log('cms data api error', er);
      throw er;
    }
  };
  return instance;
}
